<form [formGroup]="clipForm" (ngSubmit)="onSubmit()">
  <h1 mat-dialog-title>ムービークリップ</h1>
  <div mat-dialog-content>
    <div class="row mb-10" *ngIf="scope.message">
      <div class="col-md-12">
        <span class="error small">{{ scope.message }}</span>
      </div>
    </div>
    <div class="row">
      <!-- <div class="col-md-12">
        <input [owlDateTime]="dt1"  [selectMode]="'range'" [owlDateTimeTrigger]="dt1" placeholder="Date Time">
        <owl-date-time #dt1></owl-date-time>
      </div> -->
    </div>

    <!-- <div class="row">
      <div class="col-md-12">
        <mat-form-field class="full-width">
          <mat-select placeholder="管理フラグ" [(value)]="selectedAdminFlg">
            <mat-option *ngFor="let adminFlgOption of this.tenant.adminFlgOptions" [(value)]="adminFlgOption.value">
              {{adminFlgOption.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div> -->
    <!-- <div class="row">
      <div class="col-md-6">
        <input hidden="false" id="corpIcon" type="file" ng2FileSelect [uploader]="uploader" (change)="uploadSelect($event)" />
        <label for="corpIcon" #file></label>
        <button mat-stroked-button type="button" (click)="file.click()">
          アイコンの設定
        </button>
      </div>
      <div class="col-md-6">
        <img [src]="thumbnailSrc" *ngIf="!!thumbnailSrc" class="thumbnail">
      </div>
    </div> -->
  </div>
  <div mat-dialog-actions class="text-right">
    <button mat-stroked-button [mat-dialog-close]="" >close</button>
    <button mat-stroked-button cdkFocusInitial color="primary" type="submit">ダウンロード</button>    
  </div>
</form>
